import AllNewsListComponent from "../components/AllNewsList";
import useAllNews from "../hook/useAllNews";

const AllNewsList = () => {
    const useAllNewsList = useAllNews();

    return <AllNewsListComponent {...useAllNewsList} />;
};

export default AllNewsList;
